<template>
    <div class="container bg_fff">
        <breadcrumb :pages="pages"></breadcrumb>
        <div class="pl15 pr15 pt15 pb15">
            <dis_search_from @query="queryTable" ref="searchForm"></dis_search_from>
            <hos_tab_toggle v-model="tab" :list="tabList"></hos_tab_toggle>
            <div class="mt15">
                <el-table border size="mini" :data="tableList" :header-cell-style="{backgroundColor:'#fafafa'}">
                    <el-table-column label="状态" align="center" prop="ddzt" :formatter="getOrderState"></el-table-column>
                    <el-table-column label="编号" align="center" prop="orderid"></el-table-column>
                    <el-table-column label="姓名" align="center" prop="patname"></el-table-column>
                    <el-table-column label="手机号" align="center" prop="sjh"></el-table-column>
                    <el-table-column label="申请时间" align="center" prop="createTime"
                                     :formatter="formatTime"></el-table-column>
                    <el-table-column label="申请医生" align="center" prop="initDocName"></el-table-column>
                    <el-table-column label="预约医院" align="center" prop="yymc"></el-table-column>
                    <el-table-column label="预约科室" align="center" prop="ksmc"></el-table-column>
                    <el-table-column label="预约医生" align="center" prop="ysxm" :formatter="formatName"></el-table-column>
                    <el-table-column label="就诊时间" align="center" prop="_hysj"></el-table-column>
                    <el-table-column label="就诊序号" align="center" prop="yyxh"></el-table-column>
                    <!--<el-table-column label="当前叫号" align="center" prop="hopeTime" v-if="tab == 1"></el-table-column>-->
                    <el-table-column label="操作" align="center" fixed="right" width="200" v-if="tab != 3">
                        <template slot-scope="{row}">
                            <el-button size="mini" @click="lookReport(row)" v-if="tab == 2">查看诊疗记录</el-button>
                            <el-button size="mini" @click="cancleApply(row)" v-if="tab == 1 && cancle(row)">取消申请
                            </el-button>
                            <el-button size="mini" @click="getNum(row)" v-if="tab == 1 && row.ddzt == 6">签到取号
                            </el-button>
                            <el-button size="mini" v-if="tab == 1 && row.ddzt == 7">已取号</el-button>
                            <el-button size="mini" @click="enterRoom(row)" type="primary"
                                       v-if="tab == 1 && row.ddzt == 7">进入诊间
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pt15" style="text-align: center">
                <el-pagination
                    @current-change="pageChange"
                    :page-size="page.pageSize"
                    :current-page="page.pageNum"
                    layout="total, prev, pager, next, jumper"
                    :total="page.total">
                </el-pagination>
            </div>
        </div>
        <dis_diagnose_report ref="report" :info="reportInfo"></dis_diagnose_report>
        <dis_video_dialog :id="id" ref="videoDialog" :room-id="room.roomNo" @openBank="openBank"></dis_video_dialog>

        <consultation-bank-dialog ref="whiteBank"></consultation-bank-dialog>

    </div>
</template>

<script>
  import Breadcrumb from "../../components/common/Breadcrumb";
  import dis_search_from from "../../components/dis/dis-search-from";
  import hos_tab_toggle from "../../components/hos/hos-tab-toggle";
  import {dis_arr} from "../../lib/hos/until";
  import {disService} from "../../lib/service/dis"
  import dis_diagnose_report from "../../components/dis/dis-diagnose-report"
  import dis_video_dialog from "../../components/dis/dis-video-dialog";
  import {timeFormat} from "../../lib/utils"
  import ConsultationBankDialog from "../../components/consultation/bank-dialog"
  import {YCMZ_CACHE_KEY} from "../../lib/config";

  export default {
    name: "list",
    components: {
      Breadcrumb, dis_search_from, hos_tab_toggle, dis_diagnose_report, dis_video_dialog,
      ConsultationBankDialog
    },
    data() {
      return {
        pages: [],
        page: {
          pageSize: 20,
          pageNum: 1,
          total: 0
        },
        tab: 1,
        tabList: dis_arr,
        tableList: [],
        room: {},//房间号
        id: "",//订单id
        reportInfo: {}
      }
    },
    methods: {
      openBank() {
        this.$refs['whiteBank'].show();
      },
      //获取路由参数
      getRouteParam() {
        const {title} = this.$route.meta;
        this.pages = ['远程门诊', title];
      },
      //分页事件
      pageChange(num) {
        this.page.pageNum = num;
        this.queryTable();
      },
      //查看诊疗记录
      async lookReport(row) {
        this.reportInfo = await disService.queryDetail({
          outpatientId: row.orderid
        })
        this.reportInfo.ksmc = row.ksmc;
        this.$nextTick(() => {
          this.$refs['report'].showReport('1');
        })
      },
      //查询表格数据
      async queryTable() {
        let form = this.$refs["searchForm"].getForm();//查询条件表单
        form.orderState = this.tab;//单子状态
        form.pageNum = this.page.pageNum;//页码
        form.pageSize = this.page.pageSize;//每页条数
        const {list, obj} = await disService.queryLaunchList(form);
        if (list.length == 0 || obj.list.length == 0) {
          this.page.total = 0;
          this.tableList = [];
          return
        }
        const table = this.merge(obj.list, list);
        this.page.total = obj.page.total * 1;
        this.tableList = table;
      },
      //处理数据
      merge(l1, l2) {
        const backArray = [];//返回的数据
        for (let o of l1) {
          let order = l2.find(val => {
            return o.orderid == val.id
          })
          let obj = Object.assign({}, o, order);
          obj._hysj = timeFormat(obj.bookTime, '%Y-%m-%d') + ' ' + obj.hysj;
          backArray.push(obj);
        }
        return backArray;
      },
      formatTime(row, column, cellValue) {
        return timeFormat(cellValue, '%Y-%m-%d %H:%M');
      },
      getOrderState(row, column, cellValue) {
        switch (cellValue * 1) {
          case 1 :
            return "待就诊"
          case 3 :
            return "已取消"
          case 5 :
            return "已就诊"
          case 6 :
            return "待就诊"
          case 7 :
            return "待就诊"
        }
      },
      formatName(row, column, cellValue) {
        if (cellValue || cellValue != undefined) {
          return cellValue
        } else {
          return '普通号'
        }
      },
      cancle(row) {
        let {bookTime} = row;
        let data = new Date();
        if (data.getTime() < bookTime) {
          return true
        } else {
          return false
        }
      },
      //取消申请
      cancleApply(row) {
        const that = this;
        this.$confirm('您确定要取消申请吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const {code} = await disService.cnacleApply({
            "orderid": row.orderid,
            "hosId": row.yyid
          });
          if (code == 0) {
            that.$message({
              type: 'success',
              message: '取消申请成功!'
            });
            that.queryTable();
          }
        })
      },
      //签到取号
      async getNum(row) {
        const {code} = await disService.getNum({
          hosId: row.yyid,
          orderId: row.orderid,
          orderState: '0'
        });
        if (code == 0) {
          this.$message({
            type: 'success',
            message: '取号成功!'
          });
          this.queryTable();
        }
      },
      //进入诊间
      async enterRoom(row) {
        this.id = row.orderid;
        /*
                const {room = {}}  = await disService.enterRoom({
                    outpatientId:row.orderid
                })
                this.room = room;
                if (!isEmpty(room)) this.$refs.videoDialog.show(room);*/
        this.$cache.set(YCMZ_CACHE_KEY, row);
        this.$router.push({
          path: "/other/ycmz/fullscreen",
          query: {id: this.id, from: 'init'}
        })
      }
    },
    watch: {
      tab() {
        this.queryTable();//tab切换重新查询
      }
    },
    created() {
      this.getRouteParam();
    },
    mounted() {
      this.queryTable();
    }
  }
</script>

<style scoped>

</style>
